// Scoring logic for Creative Work Footprint survey

export const calculateScores = (responses) => {
  // Initialize scores for each force
  const forceScores = {
    s: [],  // The Spark
    a: [],  // The Anchor
    c: [],  // The Connector
    g: [],  // The Decider
    f: [],  // The Builder
    p: []   // The Pulse
  };

  // Collect responses for each force
  Object.keys(responses).forEach(questionId => {
    const qId = parseInt(questionId);
    const response = responses[questionId];

    // Map question ID to force (5 questions per force)
    let force;
    if (qId >= 1 && qId <= 5) force = 's';
    else if (qId >= 6 && qId <= 10) force = 'a';
    else if (qId >= 11 && qId <= 15) force = 'c';
    else if (qId >= 16 && qId <= 20) force = 'g';
    else if (qId >= 21 && qId <= 25) force = 'f';
    else if (qId >= 26 && qId <= 30) force = 'p';

    if (force) {
      forceScores[force].push(response);
    }
  });

  // Calculate normalized scores for each force (0-100 scale)
  const scores = {};
  const forces = ['s', 'a', 'c', 'g', 'f', 'p'];

  forces.forEach(force => {
    const responses = forceScores[force];
    if (responses.length === 5) {
      const sum = responses.reduce((a, b) => a + b, 0);
      // Normalize: Raw score is 5-25, convert to 0-100
      // Formula: (sum - 5) / 20 * 100
      scores[force] = Math.round((sum - 5) / 20 * 100);
    }
  });

  // Calculate category scores - normalize so total = 100%
  const thinkingSum = scores.s + scores.a + scores.c;
  const doingSum = scores.g + scores.f + scores.p;
  const totalSum = thinkingSum + doingSum;
  
  // Calculate percentages where Thinking + Doing always = 100%
  const thinkingForces = totalSum > 0 ? Math.round((thinkingSum / totalSum) * 100) : 50;
  const doingForces = 100 - thinkingForces; // Ensure they add up to 100%
  const creativeWorkScore = Math.round((thinkingSum + doingSum) / 6); // Average of all 6 forces

  // Determine balance
  const balance = thinkingForces - doingForces;
  let profileType = 'Balanced';
  if (balance > 15) {
    profileType = 'Thinking-Focused';
  } else if (balance < -15) {
    profileType = 'Doing-Focused';
  }

  // Find dominant force
  let dominantForce = 's';
  let maxScore = scores.s;
  
  Object.keys(scores).forEach(force => {
    if (scores[force] > maxScore) {
      maxScore = scores[force];
      dominantForce = force;
    }
  });

  // Assign nickname based on dominant force
  const forceNames = {
    s: 'The Spark',
    a: 'The Anchor',
    c: 'The Connector',
    g: 'The Decider',
    f: 'The Builder',
    p: 'The Pulse'
  };

  return {
    scores,
    thinkingForces,
    doingForces,
    creativeWorkScore,
    profileType,
    dominantForce,
    nickname: forceNames[dominantForce],
    balance
  };
};

export const getInterpretationMessage = (results) => {
  const { thinkingForces, doingForces, profileType } = results;

  // This will be combined with the force-specific interpretation from surveyQuestions.js
  const typeMessage = 
    profileType === 'Thinking-Focused'
      ? `You lead with Thinking Forces (${thinkingForces}%) - You naturally focus on ideation, organization, and collaboration.`
      : profileType === 'Doing-Focused'
      ? `You lead with Doing Forces (${doingForces}%) - You naturally focus on decisions, execution, and follow-through.`
      : `You have a Balanced profile - You draw equally from both Thinking and Doing Forces.`;

  return typeMessage;
};
